/**
 * Photoframe mixin
 *
 * Добавляет логику для наложения рамки на фото
 *
 */

export const CORNER_MARGIN = 20;

export const FRAME_POSITION = Object.freeze({
  TOP: 'top',
  BOTTOM: 'bottom',
  TOP_LEFT: 'top_left',
  TOP_RIGHT: 'top_right',
  BOTTOM_LEFT: 'bottom_left',
  BOTTOM_RIGHT: 'bottom_right',
});

export const GET_DRAW_NAME_BY_POSITION = Object.freeze({
  [FRAME_POSITION.TOP]: 'getTopDrawParams',
  [FRAME_POSITION.BOTTOM]: 'getBottomDrawParams',
  [FRAME_POSITION.TOP_LEFT]: 'getTopLeftDrawParams',
  [FRAME_POSITION.TOP_RIGHT]: 'getTopRightDrawParams',
  [FRAME_POSITION.BOTTOM_LEFT]: 'getBottomLeftDrawParams',
  [FRAME_POSITION.BOTTOM_RIGHT]: 'getBottomRightDrawParams',
});

export default {
  methods: {
    async drawFrame(source, frame) {
      try {
        const [image, frameImage] = await Promise.all([
          this.createImage(source),
          this.createImage(frame.src),
        ]);

        const canvas = document.createElement('canvas');
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;

        const context = canvas.getContext('2d');
        const funcName = GET_DRAW_NAME_BY_POSITION[frame.position];
        const drawFunc = this[funcName];
        const drawParams = typeof drawFunc === 'function' ? drawFunc(image, frameImage) : [];

        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        context.drawImage(frameImage, ...drawParams);

        return canvas.toDataURL();
      } catch (e) {
        console.error('Draw frame error: ', e);
        throw e;
      }
    },
    createImage(src) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => resolve(image);
        image.onerror = () => reject(src);
        image.src = src;
      });
    },
    calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
      const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
      return [srcWidth * ratio, srcHeight * ratio];
    },
    getTopDrawParams(image, frame) {
      const [dWidth, dHeight] = this.calculateAspectRatioFit(
        frame.naturalWidth,
        frame.naturalHeight,
        image.naturalWidth,
        image.naturalHeight,
      );
      return [0, 0, dWidth, dHeight];
    },
    getBottomDrawParams(image, frame) {
      const [dWidth, dHeight] = this.calculateAspectRatioFit(
        frame.naturalWidth,
        frame.naturalHeight,
        image.naturalWidth,
        image.naturalHeight,
      );
      const dy = image.naturalHeight - dHeight;
      return [0, dy, dWidth, dHeight];
    },
    getTopLeftDrawParams() {
      return [CORNER_MARGIN, CORNER_MARGIN];
    },
    getTopRightDrawParams(image, frame) {
      const dx = image.naturalWidth - frame.naturalWidth - CORNER_MARGIN;
      return [dx, CORNER_MARGIN];
    },
    getBottomLeftDrawParams(image, frame) {
      const dy = image.naturalHeight - frame.naturalHeight - CORNER_MARGIN;
      return [CORNER_MARGIN, dy];
    },
    getBottomRightDrawParams(image, frame) {
      const dx = image.naturalWidth - frame.naturalWidth - CORNER_MARGIN;
      const dy = image.naturalHeight - frame.naturalHeight - CORNER_MARGIN;
      return [dx, dy];
    },
  },
};
